import { FormRule } from "antd";
import { onlyLatinCharsDigitsSpecialSymbolsRule } from "../../utils/form.constants";

export const onlyLatinCharsDigitsRule: FormRule = {
  pattern: /^[a-zA-Z0-9\s]*$/,
  message: "Special characters are not accepted",
  validateTrigger: "onChange",
};

export const companyNameRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "Please enter name",
    validateTrigger: "onSubmit",
    whitespace: true,
  },
  {
    min: 3,
    message: "Minimum 3 characters",
    validateTrigger: "onSubmit",
  },
  {
    max: 256,
    message: "Maximum 256 characters",
    validateTrigger: "onSubmit",
  },
];
export const companyFullNameRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "Please enter full name",
    validateTrigger: "onSubmit",
  },
  {
    min: 3,
    message: "Minimum 3 characters",
    validateTrigger: "onSubmit",
  },
  {
    max: 256,
    message: "Maximum 256 characters",
    validateTrigger: "onSubmit",
  },
];
export const companyCountryRules: FormRule[] = [
  // onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "Please enter country",
    validateTrigger: "onSubmit",
  },
  {
    min: 2,
    message: "Minimum 2 characters",
    validateTrigger: "onSubmit",
  },
  {
    max: 50,
    message: "Maximum 50 characters",
    validateTrigger: "onSubmit",
  },
];
export const companyAddress1Rules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "Please enter address 1",
    validateTrigger: "onSubmit",
  },
  {
    max: 256,
    message: "Maximum 256 characters",
    validateTrigger: "onSubmit",
  },
];
export const companyAddress2Rules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    max: 256,
    message: "Maximum 256 characters",
    validateTrigger: "onSubmit",
  },
];
const companyTinVatUidBasicRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    min: 4,
    message: "Minimum 4 characters",
    validateTrigger: "onSubmit",
  },
  {
    max: 20,
    message: "Maximum 20 characters",
    validateTrigger: "onSubmit",
  },
];
export const companyDirectorsFirstNameRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "Director's first name is required",
    validateTrigger: "onSubmit",
  },
];
export const companyDirectorsLastNameRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "Director's last name is required",
    validateTrigger: "onSubmit",
  },
];
export const companyCityRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "City is required",
    validateTrigger: "onSubmit",
  },
];
export const companyPostalCodeRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "Postal Code is required",
    validateTrigger: "onSubmit",
  },
];
export const companyStateProvinceRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "State/Province is required",
    validateTrigger: "onSubmit",
  },
];
export const companyTinRules: FormRule[] = [
  ...companyTinVatUidBasicRules,
  {
    required: true,
    message: "Please enter TIN",
    validateTrigger: "onSubmit",
  },
];
export const companyTinVatUidRules: FormRule[] = [
  ...companyTinVatUidBasicRules,
  {
    required: true,
    message: "Please enter VAT/TIN/UID",
    validateTrigger: "onSubmit",
  },
];
export const companyRegistrationNumberRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "Please enter Reg №",
    validateTrigger: "onSubmit",
    whitespace: true,
  },
  {
    min: 4,
    message: "Minimum 4 characters",
    validateTrigger: "onSubmit",
  },
  {
    max: 20,
    message: "Maximum 20 characters",
    validateTrigger: "onSubmit",
  },
];

export const addressWalletRules: FormRule[] = [
  onlyLatinCharsDigitsRule,
  { required: true, message: "This field is required" },
  {
    min: 4,
    message: "Minimum 4 characters",
    validateTrigger: "onChange",
  },
  {
    max: 256,
    message: "Maximum 256 characters",
    validateTrigger: "onChange",
  },
];

export const companyTelRules: FormRule[] = [
  {
    min: 6,
    message: 'Minimum 6 characters',
    validateTrigger: 'onSubmit',
  },
  {
    max: 21,
    message: 'Maximum 21 characters',
    validateTrigger: 'onSubmit',
  },
];
export const companyTelRules2: FormRule[] = [
  {
    min: 6,
    message: 'Minimum 6 characters',
    validateTrigger: 'onSubmit',
  },
  {
    max: 21,
    message: 'Maximum 21 characters',
    validateTrigger: 'onSubmit',
  },
];
export const companyEmailRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    type: "email",
    message: "Invalid email address",
    validateTrigger: "onSubmit",
  },
  {
    required: true,
    message: "Please enter email address",
    validateTrigger: "onSubmit",
  },
  {
    max: 256,
    message: "Maximum 256 characters",
    validateTrigger: "onSubmit",
  },
];

export const ProviderNameRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "Please enter name",
    validateTrigger: "onSubmit",
    whitespace: true,
  },
  {
    min: 4,
    message: "Minimum 4 characters",
    validateTrigger: "onSubmit",
  },
  {
    max: 256,
    message: "Maximum 256 characters",
    validateTrigger: "onSubmit",
  },
];
export const ProviderFullNameRules: FormRule[] = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: "Please enter full name",
    validateTrigger: "onSubmit",
  },
  {
    min: 4,
    message: "Minimum 4 characters",
    validateTrigger: "onSubmit",
  },
  {
    max: 256,
    message: "Maximum 256 characters",
    validateTrigger: "onSubmit",
  },
];
